module.exports = __webpack_public_path__ + "static/media/tistoryIcon.16fb6e98.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tistoryIcon.png
// module id = 93
// module chunks = 0